module.exports = __webpack_public_path__ + "img/user.1b6f125a.svg";